import { useHistory } from 'react-router';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useLanguage } from '@hilma/netina2all';

import { useI18n, useSettings } from '../hooks';

import Button from './Button/Button';

const SiteIsClosed: React.FC = () => {
	const alts = useI18n(i18n => i18n.alts);
	const siteIsClosed = useI18n(i18n => i18n.siteIsClosed);
	const settings = useSettings();
	const isMobile = useMediaQuery('(max-width: 800px)'); // ! need to finish mobile!
	const language = useLanguage();
	const history = useHistory();
	const classes = useStyles();

	const opening = settings.settings?.countdownDate && new Date(settings.settings?.countdownDate);
	const openingDate = opening ? `${opening.getDate()}.${opening.getMonth() + 1}.${opening.getFullYear()}` : '';

	return (
		<>
			<div id="site-is-closed" >
				<img alt={alts.branches} width="100%" src="/lulav-icons/banner.svg" />
				<div id="site-is-closed-text">
					<div className={classes.text}>{siteIsClosed.text}{openingDate}</div>
					<div className={classes.subText}>{siteIsClosed.subText}</div>
					<Button className={classes.marginTop} onClick={() => { history.push(`/${language}/leave-details`) }}>{siteIsClosed.leaveDetailsButton}</Button>
				</div>

			</div>
		</>
	);
}

export default SiteIsClosed;

const useStyles = makeStyles(theme => ({
	marginTop: {
		marginTop: 15,
	},
	text: {
		fontFamily: 'Assistant-SemiBold'
	},
	subText: {
		fontSize: '1.4rem',
		[theme.breakpoints.down(800)]: {
			fontSize: '1.05rem'
		}
	}
}))